<template>
    <v-card elevation="0" dark color="transparent">
        <div class="list-shell">
            <div class="list-hero">
                <div class="list-kicker">
                    <v-icon small class="list-kicker-icon">{{ mdiArchiveOutline }}</v-icon>
                    <span>VIEW & MANAGE</span>
                </div>
                <h1 class="list-title">List Registered Products</h1>
                <p class="list-description">
                    Select a model to see currently registered serials. Click export to download the current list of
                    serials. Select serials from one organization and click move to transfer serials to another
                    organization.
                </p>
                <div class="list-hero-accent"></div>
            </div>

            <v-row class="list-grid" align="stretch">
                <v-col cols="12" lg="12" class="list-form-panel">
                    <v-card class="list-form-card" elevation="0" dark>
                        <v-row dense class="list-filters">
                            <v-col cols="12">
                                <div class="list-filters-row">
                                    <div class="list-filter-group">
                                        <v-text-field
                                            id="data-text-field"
                                            v-model="search"
                                            append-icon="mdi-magnify"
                                            label="Search Serial"
                                            single-line
                                            dense
                                            hide-details
                                            clearable
                                            outlined
                                            dark
                                            class="list-control"
                                        >
                                            <template v-slot:prepend-inner>
                                                <v-icon class="mt-1 mr-1" small>{{ mdiMagnify }}</v-icon>
                                            </template>
                                        </v-text-field>

                                        <v-select
                                            v-model="selectedModel"
                                            dark
                                            outlined
                                            dense
                                            item-value="model"
                                            item-text="model"
                                            label="Select Model"
                                            clearable
                                            :items="querySMModel"
                                            hide-details
                                            class="list-control"
                                            @change="$emit('list-registered', { selectedOrg, selectedModel })"
                                        >
                                            <template v-slot:prepend-inner>
                                                <v-icon class="mt-1 mr-1" small>{{ mdiPackage }}</v-icon>
                                            </template>
                                        </v-select>

                                        <v-select
                                            v-model="selectedOrg"
                                            dark
                                            outlined
                                            dense
                                            item-value="orgId"
                                            item-text="organizationName"
                                            label="Select Organization"
                                            clearable
                                            hide-details
                                            :items="orgList"
                                            :loading="loading"
                                            class="list-control"
                                            @change="$emit('list-registered', { selectedOrg, selectedModel })"
                                        >
                                            <template v-slot:prepend-inner>
                                                <v-icon class="mt-1 mr-1" small>
                                                    {{ mdiAccountSupervisorCircle }}
                                                </v-icon>
                                            </template>
                                        </v-select>
                                    </div>

                                    <div class="list-actions-col">
                                        <v-btn
                                            class="list-action-btn"
                                            color="primary"
                                            elevation="0"
                                            outlined
                                            @click="$emit('export-current')"
                                        >
                                            <v-icon small left>{{ mdiDownload }}</v-icon>
                                            Export
                                        </v-btn>
                                        <v-dialog
                                            v-model="dialog"
                                            max-width="800"
                                            :fullscreen="$vuetify.breakpoint.xsOnly"
                                            scrollable
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    v-if="userIsOrgAdmin"
                                                    class="list-action-btn"
                                                    color="primary"
                                                    elevation="0"
                                                    outlined
                                                    :disabled="!selectedSNs.length"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="$emit('get-orgs')"
                                                >
                                                    <v-icon small left>{{ mdiArrowRightBoldCircle }}</v-icon>
                                                    Move
                                                </v-btn>
                                            </template>
                                            <v-card dark class="move-dialog-card" elevation="0">
                                                <!-- Header -->
                                                <div class="move-dialog-header">
                                                    <div>
                                                        <div class="move-dialog-kicker">
                                                            <v-icon small class="move-dialog-kicker-icon">
                                                                {{ mdiArrowRightBoldCircle }}
                                                            </v-icon>
                                                            <span>TRANSFER OPERATION</span>
                                                        </div>
                                                        <h2 class="move-dialog-title">Move Serial Numbers</h2>
                                                    </div>
                                                    <v-btn
                                                        icon
                                                        text
                                                        small
                                                        class="move-dialog-close"
                                                        @click="dialog = false"
                                                    >
                                                        <v-icon>mdi-close</v-icon>
                                                    </v-btn>
                                                </div>

                                                <v-divider class="move-dialog-divider"></v-divider>

                                                <div class="move-dialog-body">
                                                    <!-- Selection Info -->
                                                    <div class="move-dialog-info">
                                                        <div class="move-info-item">
                                                            <span class="move-info-label">Selected Serials</span>
                                                            <v-chip
                                                                class="move-info-badge"
                                                                color="primary"
                                                                text-color="white"
                                                                small
                                                            >
                                                                {{ selectedSNs.length }} serial(s)
                                                            </v-chip>
                                                        </div>
                                                    </div>

                                                    <!-- Steps -->
                                                    <div class="move-dialog-steps">
                                                        <!-- Step 1: From -->
                                                        <div class="move-step">
                                                            <div class="move-step-header">
                                                                <div class="move-step-number">1</div>
                                                                <span class="move-step-title">
                                                                    Source Organization
                                                                </span>
                                                            </div>
                                                            <v-select
                                                                v-model="fromOrg"
                                                                :items="orgList"
                                                                item-text="organizationName"
                                                                item-value="orgId"
                                                                dark
                                                                outlined
                                                                dense
                                                                hide-details
                                                                clearable
                                                                label="Select source organization"
                                                                class="move-step-input"
                                                                @change="isValid"
                                                            >
                                                                <template v-slot:prepend-inner>
                                                                    <v-icon small class="mr-2">
                                                                        {{ mdiOfficeBuilding }}
                                                                    </v-icon>
                                                                </template>
                                                            </v-select>
                                                        </div>

                                                        <!-- Step 2: To -->
                                                        <div class="move-step">
                                                            <div class="move-step-header">
                                                                <div class="move-step-number">2</div>
                                                                <span class="move-step-title">
                                                                    Destination Organization
                                                                </span>
                                                            </div>
                                                            <v-select
                                                                v-model="toOrg"
                                                                :items="orgList"
                                                                item-text="organizationName"
                                                                item-value="orgId"
                                                                dark
                                                                outlined
                                                                dense
                                                                hide-details
                                                                clearable
                                                                label="Select destination organization"
                                                                class="move-step-input"
                                                                @change="isValid"
                                                            >
                                                                <template v-slot:prepend-inner>
                                                                    <v-icon small class="mr-2">
                                                                        {{ mdiOfficeBuilding }}
                                                                    </v-icon>
                                                                </template>
                                                            </v-select>
                                                        </div>
                                                    </div>

                                                    <!-- Serials Summary -->
                                                    <div v-if="selectedSNs.length" class="move-serials-summary">
                                                        <div class="move-summary-title">
                                                            <v-icon small left class="move-summary-icon">
                                                                {{ mdiFileDocumentOutline }}
                                                            </v-icon>
                                                            Selected Serials
                                                        </div>
                                                        <div class="move-serials-list">
                                                            <v-data-table
                                                                style="background-color: transparent"
                                                                dark
                                                                disable-sort
                                                                :headers="serialHeaders"
                                                                :items="selectedSNs"
                                                                hide-default-footer
                                                            >
                                                            </v-data-table>
                                                        </div>
                                                    </div>
                                                </div>

                                                <v-divider class="move-dialog-divider"></v-divider>

                                                <!-- Actions -->
                                                <div class="move-dialog-actions">
                                                    <v-btn
                                                        outlined
                                                        color="primary"
                                                        class="move-action-btn"
                                                        @click="dialog = false"
                                                    >
                                                        Cancel
                                                    </v-btn>
                                                    <v-btn
                                                        color="primary"
                                                        class="move-action-btn move-action-btn-primary"
                                                        :disabled="!validSNs || moveSubmitLoading"
                                                        :loading="moveSubmitLoading"
                                                        @click="submitMoveSerial"
                                                    >
                                                        <v-icon small left>
                                                            {{ mdiArrowRightBoldCircle }}
                                                        </v-icon>
                                                        Complete Move
                                                    </v-btn>
                                                </div>
                                            </v-card>
                                        </v-dialog>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>

                        <v-divider class="list-divider" />

                        <div class="list-table-wrapper">
                            <v-data-table
                                v-model="selectedSNs"
                                style="background-color: transparent"
                                dark
                                :headers="responsiveOptionHeaders"
                                :search="search"
                                disable-sort
                                :no-data-text="noItemsMessage"
                                :items="formattedSns"
                                item-key="_tableKey"
                                :show-select="userIsOrgAdmin"
                                :loading="loading"
                                :mobile-breakpoint="760"
                                @input="isValid"
                            >
                                <template v-slot:[`item.registerDate`]="{ item }">
                                    {{ new Date(item.registerDate).toLocaleString() }}
                                </template>
                                <template v-slot:[`item.delete`]="{ item }">
                                    <v-btn
                                        color="primary"
                                        elevation="0"
                                        text
                                        x-small
                                        @click="$emit('delete-serial', item)"
                                    >
                                        Delete
                                    </v-btn>
                                </template>
                            </v-data-table>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </v-card>
</template>

<script>
import {
    mdiArchiveOutline,
    mdiMagnify,
    mdiPackage,
    mdiAccountSupervisorCircle,
    mdiDownload,
    mdiArrowRightBoldCircle,
    mdiOfficeBuilding,
    mdiArrowDown,
    mdiFileDocumentOutline
} from '@mdi/js'

export default {
    name: 'ListRegisteredProductsTab',
    props: {
        orgList: {
            type: Array,
            default: () => []
        },
        querySMModel: {
            type: Array,
            default: () => []
        },
        registeredSns: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        userIsOrgAdmin: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            mdiArchiveOutline,
            mdiMagnify,
            mdiPackage,
            mdiAccountSupervisorCircle,
            mdiDownload,
            mdiArrowRightBoldCircle,
            mdiOfficeBuilding,
            mdiArrowDown,
            mdiFileDocumentOutline,
            search: '',
            selectedModel: '',
            selectedOrg: '',
            selectedSNs: [],
            dialog: false,
            fromOrg: '',
            toOrg: '',
            moveSubmitLoading: false,
            validSNs: false,
            noItemsMessage: 'No registered serials found.',
            noSNmessage: 'No serials selected',
            serialHeaders: [
                {
                    text: 'Selected Serial #',
                    value: 'sn',
                    align: 'left'
                }
            ],
            optionHeaders: [
                {
                    text: 'Serial #',
                    value: 'sn',
                    align: 'left'
                },
                {
                    text: 'Model',
                    value: 'model'
                },
                {
                    text: 'Organization',
                    value: 'orgName'
                },
                {
                    text: 'Asset Tag',
                    value: 'assetTag'
                },
                {
                    text: 'Location',
                    value: 'location',
                    align: 'left'
                },
                {
                    text: 'In Warranty',
                    value: 'inwarranty'
                },
                {
                    text: 'Register Date',
                    value: 'registerDate'
                },
                {
                    text: '',
                    value: 'delete'
                }
            ]
        }
    },
    computed: {
        responsiveOptionHeaders() {
            if (this.$vuetify.breakpoint.xsOnly) {
                return [
                    {
                        text: 'Serial #',
                        value: 'sn',
                        align: 'left'
                    },
                    {
                        text: 'Model',
                        value: 'model'
                    },
                    {
                        text: 'Organization',
                        value: 'orgName'
                    },
                    {
                        text: '',
                        value: 'delete'
                    }
                ]
            }

            if (this.$vuetify.breakpoint.smOnly) {
                return [
                    {
                        text: 'Serial #',
                        value: 'sn',
                        align: 'left'
                    },
                    {
                        text: 'Model',
                        value: 'model'
                    },
                    {
                        text: 'Organization',
                        value: 'orgName'
                    },
                    {
                        text: 'In Warranty',
                        value: 'inwarranty'
                    },
                    {
                        text: 'Register Date',
                        value: 'registerDate'
                    },
                    {
                        text: '',
                        value: 'delete'
                    }
                ]
            }

            return this.optionHeaders
        },
        formattedSns() {
            return this.registeredSns.map((item, i) => ({ ...item, _tableKey: item.sn + '_' + i }))
        }
    },
    methods: {
        submitMoveSerial() {
            if (!this.validSNs || this.moveSubmitLoading) {
                return
            }

            this.moveSubmitLoading = true
            this.$emit('move-serial', {
                selectedSNs: this.selectedSNs,
                fromOrg: this.fromOrg,
                toOrg: this.toOrg,
                onComplete: this.handleMoveSerialComplete
            })
        },
        handleMoveSerialComplete(success) {
            this.moveSubmitLoading = false

            if (success) {
                this.dialog = false
                this.selectedSNs = []
                this.fromOrg = ''
                this.toOrg = ''
                this.validSNs = false
            }
        },
        isValid() {
            if (this.selectedSNs.length > 0) {
                this.fromOrg = this.selectedSNs.map((item) => ({
                    orgId: item.orgId,
                    organizationName: item.orgName
                }))[0]
            }
            if (this.selectedSNs.length > 0 && this.orgList.length > 0 && !!this.fromOrg && !!this.toOrg) {
                this.validSNs = true
            } else {
                this.validSNs = false
            }
        }
    }
}
</script>

<style scoped>
.list-shell {
    position: relative;
    overflow: hidden;
    padding: 8px 0 6px;
    background: radial-gradient(circle at top right, rgba(219, 81, 32, 0.22), transparent 34%),
        radial-gradient(circle at bottom left, rgba(255, 255, 255, 0.08), transparent 30%);
    background-attachment: fixed;
    background-size: 100vw 100vh;
}

.list-shell::before {
    content: '';
    position: absolute;
    inset: 0;
    pointer-events: none;
}

.list-hero {
    position: relative;
    z-index: 1;
    margin-bottom: 24px;
    max-width: 860px;
}

.list-kicker {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    padding: 6px 12px;
    border: 1px solid rgba(219, 81, 32, 0.3);
    border-radius: 999px;
    background: rgba(219, 81, 32, 0.12);
    color: #db5120;
    font-size: 12px;
    letter-spacing: 0.16em;
    text-transform: uppercase;
}

.list-kicker-icon {
    color: #db5120 !important;
}

.list-title {
    margin: 0;
    font-size: clamp(2rem, 4vw, 3.25rem);
    line-height: 1.02;
    letter-spacing: -0.08rem;
}

.list-description {
    margin: 14px 0 0;
    max-width: 62ch;
    font-size: 1rem;
    line-height: 1.65;
    color: rgba(255, 255, 255, 0.76);
}

.list-hero-accent {
    margin-top: 14px;
    width: min(420px, 92%);
    height: 2px;
    border-radius: 999px;
    background: linear-gradient(90deg, #db5120 0%, rgba(219, 81, 32, 0.22) 100%);
}

.list-grid {
    position: relative;
    z-index: 1;
}

.list-form-panel {
    display: flex;
}

.list-form-card {
    width: 100%;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    border-radius: 20px !important;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.07), rgba(255, 255, 255, 0.03)) !important;
    box-shadow: 0 18px 48px rgba(0, 0, 0, 0.24);
    backdrop-filter: blur(18px);
    -webkit-backdrop-filter: blur(18px);
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.list-filters {
    gap: 12px;
}

.list-filters-row {
    display: flex;
    align-items: stretch;
    gap: 12px;
    width: 100%;
}

.list-filter-group {
    display: grid;
    grid-template-columns: minmax(180px, 1fr) minmax(170px, 1fr) minmax(210px, 1fr);
    gap: 12px;
    flex: 1 1 auto;
    min-width: 0;
}

.list-control {
    min-width: 0;
}

.list-control ::v-deep .v-input__slot {
    min-height: 40px !important;
}

.list-actions-col {
    display: flex;
    flex-wrap: nowrap;
    gap: 12px;
    align-items: stretch;
    flex: 0 0 auto;
}

.list-action-btn {
    letter-spacing: 0.04em;
    height: 40px;
    min-width: 130px;
    padding: 0 14px;
}

.list-divider {
    margin: 12px 0 !important;
    border-color: rgba(255, 255, 255, 0.14) !important;
}

.list-table-wrapper {
    overflow-x: auto;
    margin: 0 -24px -24px;
    padding: 0 24px 24px;
}

.list-table-wrapper ::v-deep .v-data-table__wrapper {
    min-width: 740px;
}

.move-dialog-card {
    width: 100%;
    max-height: min(90vh, 760px);
    background-color: #2a2a2a !important;
    background: #444444 !important;
    /* border: 1px solid rgba(219, 81, 32, 0.3) !important; */
    border-radius: 24px !important;
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.move-dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 28px 28px 0;
}

.move-dialog-kicker {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    padding: 6px 12px;
    border: 1px solid rgba(219, 81, 32, 0.3);
    border-radius: 999px;
    background: rgba(219, 81, 32, 0.12);
    color: #db5120;
    font-size: 11px;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    font-weight: 600;
}

.move-dialog-kicker-icon {
    color: #db5120 !important;
}

.move-dialog-title {
    margin: 0;
    font-size: 1.8rem;
    line-height: 1.1;
    letter-spacing: -0.04rem;
    color: rgba(255, 255, 255, 0.95);
    font-weight: 600;
}

.move-dialog-close {
    color: rgba(255, 255, 255, 0.6);
    transition: color 0.2s ease;
}

.move-dialog-close:hover {
    color: rgba(255, 255, 255, 0.9);
}

.move-dialog-divider {
    border-color: rgba(255, 255, 255, 0.1) !important;
    margin: 16px 0 !important;
}

.move-dialog-body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
}

.move-dialog-info {
    padding: 0 28px;
    display: flex;
    gap: 16px;
}

.move-info-item {
    display: flex;
    align-items: center;
    gap: 12px;
}

.move-info-label {
    color: rgba(255, 255, 255, 0.6);
    font-size: 0.85rem;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    font-weight: 600;
}

.move-info-badge {
    font-weight: 600;
    letter-spacing: 0.04em;
}

.move-dialog-steps {
    padding: 16px 28px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.move-step {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.move-step-header {
    display: flex;
    align-items: center;
    gap: 12px;
}

.move-step-number {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: linear-gradient(135deg, rgba(219, 81, 32, 0.2), rgba(255, 255, 255, 0.08));
    border: 2px solid rgba(219, 81, 32, 0.3);
    color: #db5120;
    font-weight: 700;
    font-size: 0.95rem;
}

.move-step-title {
    font-size: 0.95rem;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.9);
}

.move-step-input {
    padding: 0 12px;
}

.move-step-arrow {
    display: flex;
    justify-content: center;
    padding: 2px 0;
}

.move-arrow-icon {
    color: #db5120 !important;
    font-size: 24px;
}

.move-serials-summary {
    padding: 16px 28px;
    background: rgba(219, 81, 32, 0.08);
    border-top: 1px solid rgba(219, 81, 32, 0.15);
    border-bottom: 1px solid rgba(219, 81, 32, 0.15);
}

.move-summary-title {
    display: flex;
    align-items: center;
    gap: 8px;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 600;
    font-size: 0.95rem;
    margin-bottom: 12px;
}

.move-summary-icon {
    color: #db5120 !important;
}

.move-serials-list {
    max-height: 250px;
    overflow-y: auto;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 12px;
    padding: 8px 0;
}

.move-serials-list >>> .v-data-table {
    font-size: 0.9rem;
}

.move-serials-list >>> .v-data-table__wrapper {
    padding: 0 12px;
}

.move-dialog-actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    padding: 20px 28px;
}

.move-action-btn {
    letter-spacing: 0.04em;
    min-width: 120px;
    font-weight: 600;
}

.move-action-btn-primary {
    background: linear-gradient(135deg, #db5120, #c7440a) !important;
    box-shadow: 0 8px 24px rgba(219, 81, 32, 0.3);
}

.move-action-btn-primary:hover:not(:disabled) {
    box-shadow: 0 12px 32px rgba(219, 81, 32, 0.4);
}

.move-action-btn-primary:disabled {
    opacity: 0.5 !important;
}

/* Responsive Design */
@media (max-width: 959px) {
    .list-form-card {
        padding: 20px;
    }

    .list-table-wrapper {
        margin: 0 -20px -20px;
        padding: 0 20px 20px;
    }

    .list-actions-col {
        margin-top: 4px;
        width: 100%;
        justify-content: flex-end;
    }

    .list-action-btn {
        min-width: 120px;
    }

    .list-filter-group {
        grid-template-columns: repeat(3, minmax(150px, 1fr));
    }

    .move-dialog-card {
        max-height: 88vh;
    }

    .move-dialog-header {
        padding: 20px 20px 0;
    }

    .move-dialog-steps {
        padding: 12px 20px;
        gap: 8px;
    }

    .move-serials-summary {
        padding: 12px 20px;
    }

    .move-dialog-actions {
        padding: 16px 20px;
        flex-direction: column-reverse;
    }

    .move-dialog-actions .v-btn {
        width: 100%;
    }
}

@media (max-width: 600px) {
    .list-shell {
        padding-top: 0;
    }

    .list-shell::before {
        display: none;
    }

    .list-title {
        font-size: clamp(1.8rem, 8vw, 2.4rem);
    }

    .list-description {
        font-size: 0.95rem;
    }

    .list-form-card {
        padding: 16px;
        border-radius: 16px !important;
    }

    .list-hero {
        margin-bottom: 16px;
    }

    .list-table-wrapper {
        margin: 0 -16px -16px;
        padding: 0 16px 16px;
    }

    .list-filters {
        gap: 8px;
    }

    .list-filters-row {
        flex-direction: column;
        gap: 10px;
    }

    .list-filter-group {
        grid-template-columns: 1fr;
        gap: 8px;
    }

    .list-actions-col {
        flex-direction: row;
        width: 100%;
        justify-content: stretch;
        gap: 8px;
    }

    .list-action-btn {
        font-size: 0.85rem;
        height: 38px;
        min-width: 0;
        width: auto;
        flex: 1 1 auto;
    }

    .list-table-wrapper ::v-deep .v-data-table__wrapper {
        min-width: 0;
    }

    .move-dialog-card {
        height: 100dvh;
        max-height: 100dvh;
        border-radius: 0 !important;
    }

    .move-dialog-header {
        flex-direction: column;
        gap: 12px;
        padding: 16px 16px 0;
    }

    .move-dialog-title {
        font-size: 1.4rem;
    }

    .move-dialog-close {
        align-self: flex-end;
    }

    .move-dialog-info {
        padding: 0 16px;
        flex-direction: column;
    }

    .move-dialog-steps {
        padding: 12px 16px;
        gap: 8px;
    }

    .move-step-arrow {
        padding: 0;
    }

    .move-arrow-icon {
        font-size: 20px;
    }

    .move-serials-summary {
        padding: 12px 16px;
    }

    .move-serials-list {
        max-height: 170px;
    }

    .move-dialog-actions {
        padding: 12px 16px;
        gap: 8px;
    }

    .move-action-btn {
        min-width: 100px;
        font-size: 0.9rem;
    }
}
</style>
